<template>
	<!-- <div @click.once="unlockAudio">
		<router-view />
		<audio ref="notifyAudio" preload="auto">
			<source src="/static/notify.mp3" type="audio/mpeg" />
		</audio>
	</div> -->
	<div>
		<router-view></router-view>
		<audio ref="notifyAudio" preload="auto">
			<source src="/static/notify.mp3" type="audio/mpeg" />
		</audio>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	import {
		wsUri
	} from './views/config/res.js'
	export default {
		components: {},
		data() {
			return {
				passvalue: {
					wsUri: wsUri,
				},
				audio: null,
				audioUnlocked: false,
			}
		},
		created() {
			this.checkDevice()
		},
		mounted() {
			this.audio = new Audio('/static/notify.mp3')
			window.addEventListener('mousedown', this.unlockAudio, {
				once: true
			})
		},
		computed: {
			...mapState(["config", 'token', ]),
			...mapState('kefu', ['notifyMessage','playVoice','shake']),
		},
		watch: {
			token: {
				immediate: true,
				async handler(newToken) {
					// 1️⃣ 没 token，直接不处理（未登录 / 已退出）
					if (!newToken) return

					// 2️⃣ 首次登录 or 刷新恢复 token
					console.log('[App] token ready:', newToken)

					// 3️⃣ 拉用户信息 + 建立 socket
					await this.getInfo()
				}
			},
			notifyMessage: {
				handler(val) {
					if (val) {
						this.$notify({
							title: '警告',
							message: val,
							type: 'warning'
						});
					}
				},
				immediate: true
			},
			playVoice: {
				handler(val) {
					if (!val) return
					this.playAudio()
					this.$notify({
						title: '提示',
						message: '您有新消息',
						type: 'info'
					});
				}
			},
			// shake: {
			// 	handler(val) {
			// 		console.log('[App] shake ready:', val)
			// 		// this.$notify({
			// 		// 	title: '警告',
			// 		// 	message: val,
			// 		// 	type: 'warning'
			// 		// });
			// 	},
			// 	immediate: true
			// },
		},
		methods: {
			...mapMutations(["setConfig"]),
			async checkDevice() {
				const res = await this.$axios.get(this.$apis.getConfig)
				if (res.code != 1) return
				console.log(this.config, '基础数据');
				this.setConfig(res.data)
				if (!localStorage.getItem('defaultLang')) {
					localStorage.setItem('defaultLang', this.config.defaultLang)
					this.initLanguage()
				}
			},
			initLanguage() {
				let lang = localStorage.getItem('defaultLang') || 'zh'
				console.log('初始化语言为:', lang)
				this.$i18n.locale = lang
			},
			async getInfo() {
				const res = await this.$axios.get(this.$apis.getInfo, {})
				if (res.code == 1) {
					let userInfo = res.data
					this.$kefuSocket.connect({
						wsUri: this.passvalue.wsUri,
						token: userInfo.chat_token,
						expire_time: userInfo.expire_time,
						customer_service_id: userInfo.id,
						channel_key: userInfo.channel.key,
					})
				}
			},
			async unlockAudio() {
				const audio = this.$refs.notifyAudio
				try {
					await audio.play() // 真正等成功
					audio.pause()
					audio.currentTime = 0
					this.audioUnlocked = true
					console.log('🔓 audio unlocked')
				} catch (e) {
					console.warn('unlock failed', e)
				}
			},
			playAudio() {
				if (!this.audioUnlocked) {
					console.warn('音频未解锁，跳过播放')
					return
				}

				const audio = this.$refs.notifyAudio
				audio.currentTime = 0
				audio.volume = 1
				audio.muted = false
				audio.play().catch(err => {
					console.warn('play failed', err)
				})
			},
		}
	}
</script>
<style>
	* {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
		/* 建议加上，防止 padding 撑开宽度 */
	}

	html,
	body,
	#app {
		width: 100%;
		height: 100%;
		overscroll-behavior: none;

	}
</style>